import env from '../config/environment';

export const lgpdConsentBody = (proposalId, cpf, subprocess, consent) => {
  return {
    sistema: {
      codigo: env.LGPD_SYSTEM_CODE,
    },
    unidadeNegocio: {
      codigo: parseInt(env.BUSINESS_UNITY_CODE),
    },
    processoNegocio: {
      subProcesso: {
        codigo: parseInt(subprocess),
      },
      macroProcesso: {
        codigo: parseInt(env.MACRO_PROCESS_CODE),
      },
    },
    cliente: {
      codigo: cpf,
    },
    evidencia: {
      codigo: proposalId, //  Número da proposta gerada.
    },
    consentimento: {
      tipo: parseInt(consent), // Indica tipo consentimento 1-Ativo 0-Inativo
    },
  };
};
